var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-company-edit-wrapper",
    { attrs: { company: _vm.value, "no-scroll": "" } },
    [
      _c(
        "w-button-bar",
        { attrs: { slot: "actions" }, slot: "actions" },
        [
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Gebruiker toevoegen",
                  expression: "'Gebruiker toevoegen'",
                },
              ],
              attrs: { disabled: _vm.addDisabled },
              on: {
                click: function ($event) {
                  return _vm.addUserClicked()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "plus" } })],
            1
          ),
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Gebruiker bewerken",
                  expression: "'Gebruiker bewerken'",
                },
              ],
              attrs: { disabled: _vm.selected.length != 1 },
              on: {
                click: function ($event) {
                  return _vm.editUser()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "pen" } })],
            1
          ),
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Toestellen beheren",
                  expression: "'Toestellen beheren'",
                },
              ],
              on: {
                click: function ($event) {
                  return _vm.manageUserDevices()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "desktop" } })],
            1
          ),
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Ticket aanmaken",
                  expression: "'Ticket aanmaken'",
                },
              ],
              attrs: { disabled: _vm.selected.length != 1 },
              on: {
                click: function ($event) {
                  return _vm.createTicket()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "life-ring" } })],
            1
          ),
          _c(
            "app-login-as-user-button",
            {
              attrs: {
                admin: "",
                clsas: "link",
                disabled: _vm.selected.length != 1,
                user: _vm.selected[0],
              },
            },
            [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Aanmelden met admin rechten",
                      expression: "'Aanmelden met admin rechten'",
                    },
                  ],
                  attrs: { disabled: _vm.selected.length != 1 },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c("w-fa", {
                    staticClass: "sign-in-button",
                    attrs: { icon: "headset" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "app-login-as-user-button",
            {
              attrs: {
                clsas: "link",
                disabled: _vm.selected.length != 1,
                user: _vm.selected[0],
              },
            },
            [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Aanmelden als gebruiker",
                      expression: "'Aanmelden als gebruiker'",
                    },
                  ],
                  attrs: { disabled: _vm.selected.length != 1 },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c("w-fa", {
                    staticClass: "sign-in-button",
                    attrs: { icon: "sign-in-alt" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Gebruiker verwijderen",
                  expression: "'Gebruiker verwijderen'",
                },
              ],
              attrs: { disabled: _vm.selected.length == 0 },
              on: {
                click: function ($event) {
                  return _vm.removeUsers()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "minus" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { attrs: { grow: "" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-data-table", {
                staticStyle: { "flex-grow": "1" },
                attrs: {
                  items: _vm.orderedUsers,
                  columns: _vm.columns,
                  order: _vm.orderColumn,
                  "order-direction": _vm.orderDirection,
                  "selected-items": _vm.selected,
                },
                on: {
                  order: function ($event) {
                    return _vm.onOrder($event)
                  },
                  "item-clicked": function ($event) {
                    return _vm.editUser($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.editModal,
            callback: function ($$v) {
              _vm.editModal = $$v
            },
            expression: "editModal",
          },
        },
        [
          _c("app-company-edit-user-modal", {
            attrs: { value: _vm.toEditUser },
            on: {
              input: function ($event) {
                return _vm.onUserSave($event)
              },
              close: function ($event) {
                _vm.editModal = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.manageUserDevicesModal } },
        [
          _c("app-company-edit-user-devices", {
            attrs: { "company-id": _vm.value.id },
            on: {
              close: function ($event) {
                _vm.manageUserDevicesModal = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }